exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".sidebar[data-v-6c4919b7]{position:absolute;top:5px;bottom:10px;width:7px;background:url(" + require("../images/grip.png") + ") no-repeat 50% 50%;border:1px solid gray;background-color:#fff;cursor:col-resize}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-6c4919b7&scoped=true!./~/less-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/sidebar.vue
// module id = 10
// module chunks = 0